import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useRef } from 'react';
import styled, { css } from 'styled-components';
import i18n from 'i18n';
import { pxToRem } from 'utils/ui/units';
import { getColorBlock } from 'utils/ui/colors';
import useChartist from 'hooks/useChartist';
import useBreakpoints from 'hooks/useBreakpoints';
import Box from 'components/Box';
import StripesPattern from './StripesPattern';
var Wrapper = styled.div.withConfig({
  displayName: "SimpleGauge__Wrapper",
  componentId: "sc-15584oi-0"
})(["position:relative;overflow:hidden;", " > svg{vertical-align:middle;color:", ";", " ", "}.ct-slice-donut{stroke:none;fill:none;}.ct-series-a{fill:", ";}.ct-series-b{fill:currentColor;opacity:0.2;}"], function (p) {
  return p.height && css(["height:", ";"], pxToRem(p.height));
}, function (p) {
  return getColorBlock(p.gaugeColor, p.theme);
}, function (p) {
  return p.height && css(["height:", ";"], pxToRem(p.height * 2));
}, function (p) {
  return p.patternId && "\n\t\t\topacity: 0.2;\n\t\t";
}, function (p) {
  return p.patternId ? "url(#".concat(p.patternId, ") currentColor") : 'currentColor';
});
var defaultOptions = {
  startAngle: 270,
  // Needed for half-circle: start from bottom → arc goes upwards
  total: 200,
  // Needed for half-circle: makes [x, 100 - x] cover only 180°
  showLabel: false,
  chartPadding: 0
};
function SimpleGauge(_ref) {
  var value = _ref.value,
    height = _ref.height,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'links' : _ref$color,
    isEmpty = _ref.isEmpty,
    _ref$emptyContent = _ref.emptyContent,
    emptyContent = _ref$emptyContent === void 0 ? i18n.t('empty_no_data') : _ref$emptyContent;
  var _useBreakpoints = useBreakpoints(),
    isLargeScreen = _useBreakpoints.xxl;
  var hostRef = useRef(null);
  var hasValue = typeof value !== 'undefined' && value !== null && !isEmpty;
  var fraction = (hasValue ? value : Math.random()) * 100;
  var options = _objectSpread(_objectSpread({}, defaultOptions), {}, {
    height: isLargeScreen ? height * 2.4 : height * 2
  });
  useChartist(hostRef, {
    type: 'Pie',
    data: {
      series: [fraction, 100 - fraction]
    },
    options: options
  });
  var patternIdRef = useRef("gauge-chart-".concat(Math.random()));
  return /*#__PURE__*/React.createElement(Wrapper, {
    ref: hostRef,
    height: height,
    gaugeColor: color,
    patternId: hasValue ? null : patternIdRef.current
  }, !hasValue && /*#__PURE__*/React.createElement(Box, {
    dimmed: true,
    bottom: true,
    right: true,
    breakpoints: "xxl",
    position: "absolute",
    mx: "xs",
    my: ['xxs', 's']
  }, emptyContent, /*#__PURE__*/React.createElement(StripesPattern, {
    color: color,
    id: patternIdRef.current
  })));
}
export default SimpleGauge;